import axios from "axios";
import { ENV, getDomainHeader } from "../../../env";

const axiosInstance = axios.create({
  baseURL: ENV.baseURL,
});

// Attach token and domain header to every request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }

  config.headers["Domain"] = getDomainHeader("");
  return config; 
});

export default axiosInstance;
